import React, { useState } from 'react';
import { Carousel } from 'antd';
import { Image } from 'theme-ui';

type ServiceProviderPhotoGalleryCarouselProps = {
  photos: {
    uid: string;
    imageFile: {
      uploadedFile: {
        publicUrl: string;
      };
    };
  }[] | null;
  bannerImageSrc: string | null;
  introVideoUrl: string | null;
};

const ServiceProviderPhotoGalleryCarousel: React.FC<ServiceProviderPhotoGalleryCarouselProps> = ({
  photos,
  bannerImageSrc,
  introVideoUrl,
}) => {
  const [isAutoplayPaused, setIsAutoplayPaused] = useState(false);

  return (
    <div
      className="max-h-[512px] overflow-hidden relative w-full"
    >
      {(photos && photos.length > 0 || introVideoUrl) ? (
        <Carousel
          autoplay={!isAutoplayPaused}
          dots={(photos?.length || 0) + 1 > 1}
          dotPosition="bottom"
          autoplaySpeed={6000}
          fade
        >
          {introVideoUrl && (
            <div
              className="w-full pt-[56.25%] relative"
            >
              <iframe
                src={introVideoUrl}
                onClick={() => setIsAutoplayPaused(!isAutoplayPaused)}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="absolute top-0 left-0 w-full h-full object-contain max-h-[100%] bg-transparent"
              ></iframe>
            </div>
          )}
          {photos?.map((p) => (
            <div
              key={p.uid}
              className="w-full pt-[56.25%] relative"
            >
              <Image
                src={p.imageFile.uploadedFile.publicUrl}
                alt="service provider image"
                className="absolute top-0 left-0 w-full h-full object-contain max-h-[100%] bg-transparent"
                style={{
                  borderRadius: '10px',
                  margin: 0,
                  color: 'black',
                  textAlign: 'center',
                  fontSize: '1rem',
                }}
              />
            </div>
          ))}
        </Carousel>
      ) : bannerImageSrc ? (
        <Image src={bannerImageSrc} alt="service provider banner image" />
      ) : null/** maybe some default image? */}
    </div>
  );
};

export default ServiceProviderPhotoGalleryCarousel;

